/* eslint-disable no-undef */
import axios from 'axios'
import { userAgent } from '@/helpers'

axios.defaults.headers.common['UserAgent'] = userAgent()

const corporateLogin = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/Authentication/Authenticate`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const corporateSms = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/Authentication/ValidateOTP`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const resendSms = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/Authentication/SendOTP`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const forget = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/Authentication/Forget`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const register = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/Authentication/Register`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const createPassword = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/Authentication/CreatePassword`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const createOffer = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/AutomaticAttendanceOffer/CreateOffer`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const TcKontrol = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/AutomaticAttendanceOffer/TcKontrol`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const validateCaptcha = (form) => {
	return new Promise((resolve, reject) => {
		return axios.post(`${_api.corporate}/Authentication/validateCaptcha`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
export { corporateLogin, corporateSms, resendSms, forget, register, createPassword ,createOffer,TcKontrol,validateCaptcha}